export default "__VITE_ASSET__CboWYXat__"